<h2 class="dialogTitle"> {{'Footer.Privacy'|translate}}</h2>
<mat-dialog-content [innerHTML]="'Privacy.Text' | translate">
</mat-dialog-content>
<mat-dialog-actions align="center">
        <button type="button" color="accent" mat-flat-button  mat-dialog-close="false">{{'Actions.Close'|translate}}</button>
    </mat-dialog-actions>
